import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import { vodSettingsAdapter } from 'shared/utils/adapters/vod-settings';

const ACTIONS = createAsyncActions('SERVER.VOD-SETTINGS.RESET');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;


export default function () {
  return function (dispatch) {
    dispatch(START());

    return vodSettingsAdapter.reset()
      .then(
        function (result) {
          dispatch(SUCCESS({}, result));
          return result;
        },


        function (reason) {
          dispatch(FAIL(null, null, { analytics: { type: 'error', payload: { name: 'shared.vod-settings.reset' } } }));
          return Promise.reject(reason);
        }
      );
  };
}



// WEBPACK FOOTER //
// ./src/shared/redux/server/actions/vod-settings/reset.js